import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthGuardService } from '../authentication/auth-guard.service';
import { ViolationsComponent } from './violations.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { FuseWidgetModule } from '@fuse/components';
import { MatTabsModule } from '@angular/material';
import { CommonViolationsComponent } from './common/common-violations/common-violations.component';
import { MaterialModule } from 'app/shared/material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RoundProgressModule } from 'angular-svg-round-progressbar';
import { CommonModule } from '@angular/common';
import { EmployeesViolationsComponent } from './employees-violations/employees-violations.component';
import { LeaderViolationsComponent } from './leader-violations/leader-violations.component';
import { CommonLeaderComponent } from './common/common-leader/common-leader.component';
import { AdminComponent } from './common/admin/admin.component';
import { AdminViolationsComponent } from './admin-violations/admin-violations.component';
import { TeamComponent } from './common/team/team.component';
import { TeamViolationComponent } from './team-violation/team-violation.component';

const routes = [
    { path: '', redirectTo: 'violations', pathMatch: 'full', canActivate: [AuthGuardService] },
    { path: 'violations', component: ViolationsComponent, canActivate: [AuthGuardService] },
];

@NgModule({
    imports: [
        RouterModule.forChild(routes),
        MatIconModule,
        MatFormFieldModule,
        FuseWidgetModule,
        MatTabsModule,
        FlexLayoutModule,
        MaterialModule,
        RoundProgressModule,
        CommonModule
    ],
    declarations: [
        ViolationsComponent,
        CommonViolationsComponent,
        EmployeesViolationsComponent,
        LeaderViolationsComponent,
        CommonLeaderComponent,
        AdminComponent,
        AdminViolationsComponent,
        TeamComponent,
        TeamViolationComponent
    ],
    exports:[
        CommonViolationsComponent
    ]
})

export class ViolationsModule { }
